import { render, staticRenderFns } from "./PRCreateTemplate.vue?vue&type=template&id=e7a5258e&"
import script from "./PRCreateTemplate.vue?vue&type=script&lang=js&"
export * from "./PRCreateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7a5258e')) {
      api.createRecord('e7a5258e', component.options)
    } else {
      api.reload('e7a5258e', component.options)
    }
    module.hot.accept("./PRCreateTemplate.vue?vue&type=template&id=e7a5258e&", function () {
      api.rerender('e7a5258e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/creationPages/PRCreateTemplate.vue"
export default component.exports